import { render } from "./Aboat.vue?vue&type=template&id=0df8bae4&scoped=true&ts=true"
import script from "./Aboat.vue?vue&type=script&setup=true&lang=ts"
export * from "./Aboat.vue?vue&type=script&setup=true&lang=ts"

import "./Aboat.vue?vue&type=style&index=0&id=0df8bae4&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df8bae4"],['__file',"src/views/me/Aboat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0df8bae4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0df8bae4', __exports__)) {
    console.log('reload')
    api.reload('0df8bae4', __exports__)
  }
  
  module.hot.accept("./Aboat.vue?vue&type=template&id=0df8bae4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0df8bae4', render)
  })

}


export default __exports__